import React from 'react'

//import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    formataValor,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataEstudoDiagnosticoAposentadoriaResumo,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    //DivFormEstudo,
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    anoPrimeiraLetraMaiscula,
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    calculaJaAposentou,
} from '../estudo-form/EstudoServiceCalculo'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'



const SimulacaoFinanceiraFormEvolucaoReservaFinanceira = ( { values, estudo, report, popup, indInicial, indFinal } ) => {

    const EvolucaoReservaFinanceira = ( props ) => {

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(anoPrimeiraLetraMaiscula(), report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' + LABEL.comeco, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.aporteMensal, report),
            },
        ]

        if (/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && */values.exibirEvolucaoAporteMensalInflacao) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.aporteMensalEvolucaoInflacaoQuebraEspecial, report),
                },
            )
        }

        headList.push(
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.retiradaMensal, report),
            },
        )

        if (/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && */values.exibirEvolucaoRetiradaMensalInflacao) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.retiradaMensalEvolucaoInflacaoQuebraEspecial, report),
                },
            )
        }

        headList.push(
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.aporteRetiradaAnual, report),
            },
        )

        if (!values.exibirEvolucaoRecursosFinanceirosFinalInflacao) {

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.rendimentoMensal, report),
                },
            )
        }

        headList.push(
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' + LABEL.final, report),
            },
        )

        if (values.exibirEvolucaoRecursosFinanceirosFinalInflacao) {

            headList.push(
                {
                    colSpan: 6,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' +
                            LABEL.final + ' ' + LABEL.evolucaoInflacao, report),
                },
            )
        }

        const evolucaoReservaFinanceira =
            report
                ?
                    estudo.current.evolucaoReservaFinanceiraReport
                :
                    estudo.current.evolucaoReservaFinanceira

        return (
            <div
                {...props}
            >
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {evolucaoReservaFinanceira?.map((item, ind) => {

                            let colSpan = 0

                            return !indFinal || (ind >= indInicial && ind <= indFinal) ? (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.ano}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.idadeGraficos}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.recursosFinanceirosInicio}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.aporteMensal}
                                    </TableCellBodyExibeDados>

                                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal &&*/
                                    values.exibirEvolucaoAporteMensalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {item.aporteMensalEvolucaoInflacao}
                                        </TableCellBodyExibeDados>
                                    )}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.retiradaMensal}
                                    </TableCellBodyExibeDados>

                                    {/*values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal &&*/
                                    values.exibirEvolucaoRetiradaMensalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {item.retiradaMensalEvolucaoInflacao}
                                        </TableCellBodyExibeDados>
                                    )}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.aporteRetiradaAnual}
                                    </TableCellBodyExibeDados>
                                    
                                    {!values.exibirEvolucaoRecursosFinanceirosFinalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {item.rendimentoMensal}
                                        </TableCellBodyExibeDados>
                                    )}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {item.recursosFinanceirosFinal}
                                    </TableCellBodyExibeDados>

                                    {values.exibirEvolucaoRecursosFinanceirosFinalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {item.recursosFinanceirosFinalEvolucaoInflacao}
                                        </TableCellBodyExibeDados>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                            :
                            (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                />
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>

                {(!indFinal || indFinal >= evolucaoReservaFinanceira.length - 1) && 
                !calculaJaAposentou(values, ano(values.dataSimulacaoEstudo)) && (
                        <GridItem12
                            className='mt-5 mb-5' //mt-10
                            align='center'
                        >
                            {formataEstudoDiagnosticoAposentadoriaResumo(
                                MESSAGE().resumoEvolucaoReservaFinanceira
                                    .replace('$1$', formataValor(values.reservaInicial, 2))
                                        .replace('$2$', formataValor(values.totalAportesAteAposentadoria, 2))
                                            .replace('$3$',
                                                formataValor(round(values.reservaInicioAposentadoria - values.reservaInicial -
                                                    values.totalAportesAteAposentadoria, 2), 2))
                                                        .replace('$4$', formataValor(values.reservaInicioAposentadoria, 2))
                            )}
                        </GridItem12>
                )}
            </div>
        )
    }

    return (
        report || relatorioModoApresentacao(values)
            ?
                //<DivFormEstudo
                    //className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                //>
                    <EvolucaoReservaFinanceira/>
                //</DivFormEstudo>
            :
                popup
                    ?
                        <DivOverflowX>
                            <EvolucaoReservaFinanceira/>
                        </DivOverflowX>
                    :
                        <CardGridEstudoPadrao
                            label={LABEL.evolucaoReservaFinanceira}
                            component={
                                <EvolucaoReservaFinanceira/>
                            }
                            overflowX={true}
                        />
    )
}

export default SimulacaoFinanceiraFormEvolucaoReservaFinanceira